import { INGREDIENTS } from "@/lib/content";
import { useReveal } from "@/lib/useReveal";

export const Ingredients = () => {
  const { ref, inView } = useReveal();
  return (
    <section className="py-12 sm:py-16 lg:py-20" ref={ref}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className={`mb-10 text-center hp-reveal ${inView ? "in-view" : ""}`}>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700">
            100% Pure Ayurvedic
          </span>
          <h2 className="mt-3 font-display text-3xl uppercase text-neutral-900 sm:text-4xl">Key Ingredients</h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-neutral-600">
            A balanced blend of 5 powerful Ayurvedic herbs.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
          {INGREDIENTS.map((ing, i) => (
            <div
              key={ing.name}
              data-testid={`ingredient-card-${i}`}
              className={`overflow-hidden rounded-2xl border border-neutral-200 bg-white hp-reveal ${
                inView ? "in-view" : ""
              }`}
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <img src={ing.img} alt={ing.name} className="aspect-square w-full object-cover" />
              <div className="p-4">
                <h3 className="font-display text-base text-neutral-900">{ing.name}</h3>
                <p className="text-[11px] font-semibold uppercase tracking-wide text-[var(--hp-crimson)]">
                  {ing.en}
                </p>
                <p className="mt-2 text-xs leading-relaxed text-neutral-600">{ing.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
